"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var GalleryImage_1 = __importDefault(require("./GalleryImage"));
var isImageMetadataSuccess_1 = require("../utils/isImageMetadataSuccess");
function SizedImage(props) {
    var _a;
    var showBoundingBox = props.showBoundingBox, imageId = props.imageId, adId = props.adId, imageMetadata = props.imageMetadata, isModalOpen = props.isModalOpen;
    var sizedImageContainerSize = { width: 80, height: 80 };
    var cropping = (0, isImageMetadataSuccess_1.isImageMetadataSuccess)(imageMetadata) && ((_a = imageMetadata.transformations) === null || _a === void 0 ? void 0 : _a.cropping);
    return (react_1.default.createElement(GalleryImage_1.default, { isModalOpen: isModalOpen, imageId: imageId, adId: adId, type: cropping ? 'fullImage' : 'sizedImage', containerSize: sizedImageContainerSize, showBoundingBox: showBoundingBox, showFailedToDownloadImageText: false, isClickable: true }));
}
exports.default = SizedImage;
